export default __webpack_public_path__ + "static/media/JapaneseColdBrew.5f04a0ea.webp";